import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../core/interceptor/http-interceptor-config";
import Api from "../core/api/api";

export const saveAudio = createAsyncThunk(
  "transcription/saveAudio",
  async (formdata: any) => {
    return await axiosInstance.post(Api.upload_recording, formdata);
  }
);

export const getUplodRecordingList = createAsyncThunk(
  "transcription/getUplodRecordingList",
  async (data: any) => {
    return await axiosInstance.get(Api.upload_recording + data);
  }
);

export const getRecordingStatus = createAsyncThunk(
  "transcription/getRecordingStatus",
  async (recording_id: string) => {
    return await axiosInstance.get(
      Api.recording_status + "?recording_id=" + recording_id
    );
  }
);

export const updateTranscript = createAsyncThunk(
  "transcription/updateTranscript",
  async (updateObj: any) => {
    return await axiosInstance.put(Api.update_transcription, updateObj);
  }
);

export const updateSummary = createAsyncThunk(
  "transcription/updateSummary",
  async (updateObj: any) => {
    return await axiosInstance.put(Api.update_summary, updateObj);
  }
);
// Fetch Domain Categories
export const getDomainCategories = createAsyncThunk(
  "transcription/getDomainCategories",
  async () => {
    return await axiosInstance.get(Api.domain_category);
  }
);

// Fetch Language Categories
export const getLanguageCategories = createAsyncThunk(
  "transcription/getLanguageCategories",
  async () => {
    return await axiosInstance.get(Api.language_category);
  }
);
export const deleteTranscription = createAsyncThunk(
  "transcription/deleteTranscription",
  async (recording_id: string) => {
    return await axiosInstance.delete(
      Api.update_transcription + "?recording_id=" + recording_id
    );
  }
);

export const getSpeechRecognitionKPI = createAsyncThunk(
  "kpi/getSpeechRecognitionKPI",
  async () => {
    return await axiosInstance.get(Api.speech_recognition_kpi);
  }
);
